<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <h1>{{(task ? 'Edit task' : 'Add task') | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="row">
          <div class="L-12 M-12 S-12 columns">
            <div class="L-12 M-12 S-12 columns">
              <label>{{'Task name' | translate}}**</label>
              <input type="text" maxlength="200" name="task_name" [(ngModel)]="formData.task_name" placeholder="{{'Insert' | translate}}" required>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Phase' | translate}}**</label>
              <app-dropdown
                [(appModel)]="formData.project_has_phase_id"
                (onClose)="onChangePhase()"
                [list]="project.phases_project"
                [value]="'id'"
                [name]="'phase'"
                [backTranslate]="true"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Task unit' | translate}}** {{formData.task_unit_id}}</label>
              <app-dropdown
                [(appModel)]="formData.task_unit_id"
                [list]="infoProjectPhases.task_unit"
                [value]="'id'"
                [name]="'task_unit'"
                [backTranslate]="true"
                (appModelChange)="ValidateWeek(); filterPredecessor()"
              ></app-dropdown>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Duration' | translate}}** {{weeks === true}}</label>
              <div class="row">
                <div class="L-4 M-4 S-4 columns">
                  <input class="centered" type="text" decimals="1" name="duration"  [(ngModel)]="formData.duration" placeholder="{{'#' | translate}}" required>
                </div>
                <div class="L-8 M-8 S-8 columns">
                  <app-dropdown
                    [(appModel)]="formData.task_duration_type_id"
                    [list]="infoProjectPhases.task_duration_type"
                    [value]="'id'"
                    [disabled]="weeks === true"
                    [name]="'task_duration'"
                    [backTranslate]="true"
                  ></app-dropdown>
                </div>
              </div>
            </div>
            <div class="L-4 M-4 S-4 columns">
              <label>{{'Predecessor' | translate}}</label>
              <app-dropdown
                [(appModel)]="formData.predecessor_id"
                [list]="predecessorsFilter"
                [disabled]="!formData.project_has_phase_id || !predecessors.length || disablePre"
                [value]="'id'"
                [name]="'task_name'"
              ></app-dropdown>
            </div>
            @if (formData.predecessor_id && formData.predecessor_id > -1) {
              <div class="L-4 M-4 S-4 columns">
                <label>{{'Start at' | translate}}</label>
                <app-dropdown
                  [(appModel)]="formData.task_start_at_id"
                  [list]="infoProjectPhases.task_start_at"
                  [disabled]="!formData.project_has_phase_id || !predecessors.length"
                  [value]="'id'"
                  [name]="'task_start'"
                  [backTranslate]="true"
                ></app-dropdown>
              </div>
            }
            @if (formData.task_unit_id == 1 && formData.task_duration_type_id != 2) {
              <div class="L-4 M-4 S-4 columns">
                <label>{{'Max chapters' | translate}}</label>
                <input type="text" pattern="^[1-9][0-9]*$" numeric name="break_episode" [(ngModel)]="formData.break_episode" placeholder="{{'#' | translate}}">
              </div>
            }
            @if (formData.task_duration_type_id == 1 && formData.task_unit_id != 3) {
              <div class="L-4 M-4 S-4 columns">
                <label>{{'Weekly days' | translate}}**</label>
                <input type="text" pattern="[1-7]" required numeric name="work_days" [(ngModel)]="formData.work_days" placeholder="{{'#' | translate}}">
              </div>
            }
            @if (formData.predecessor_id == -1) {
              <div class="L-4 M-4 S-6 columns">
                <label>{{'Date from' | translate}}</label>
                <input class="centered" type="date" name="date_from" [value]="'id'" [disabled]="disabledDate" [name]="'date_task'"[(ngModel)]="formData.date_task" placeholder="{{'Insert date' | translate}}">
              </div>
            }
            @if (module?.name == 'post') {
              <div class="L-4 M-4 S-12 columns">
                <label>{{'Color' | translate}}</label>
                <input type="color" name="post_color" [(ngModel)]="formData.post_color">
              </div>
            }
            <div class="L-6 M-6 S-12 columns">
              <label>{{'Country' | translate}}</label>
              <app-dropdown
                [(appModel)]="formData.task_countrys"
                [list]="infoProjectPhases.countries"
                [value]="'id'"
                [backTranslate]="true"
                [name]="'prod_center'"
                [multiple]="true"
              ></app-dropdown>
            </div>
          </div>
        </div>
        @if (showError) {
          <div class="errorMessage" style="margin-top: 14px; margin-bottom: 12px;">{{'Weeks cannot be decreased' | translate}}</div>
        }
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid || !formIsValid()">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>